import type { AssessmentCategoryKey } from "../assessment-types";

/**
 * Browsing category + extra search terms for the original twelve
 * assessments, whose data files predate the category field.
 *
 * New assessments should declare `category` and `keywords` on the assessment
 * itself; this map is only a fallback so nothing ever lands uncategorised.
 */
export const ASSESSMENT_TAXONOMY: Record<
  string,
  { category: AssessmentCategoryKey; keywords: string[] }
> = {
  "trauma-responses": {
    category: "nervous-system",
    keywords: ["fight", "flight", "freeze", "fawn", "survival response", "threat", "stress"],
  },
  "nervous-system": {
    category: "nervous-system",
    keywords: ["regulation", "polyvagal", "window of tolerance", "activation", "shutdown", "calm"],
  },
  hypervigilance: {
    category: "nervous-system",
    keywords: ["on edge", "alert", "scanning", "startle", "danger", "watchful", "tense"],
  },
  "emotional-regulation": {
    category: "emotions",
    keywords: ["overwhelm", "big feelings", "mood", "calm down", "soothe", "intensity"],
  },
  numbness: {
    category: "emotions",
    keywords: ["numb", "shutdown", "flat", "empty", "disconnected", "collapse"],
  },
  attachment: {
    category: "relationships",
    keywords: ["anxious", "avoidant", "secure", "disorganised", "closeness", "bonding"],
  },
  "trauma-bonds": {
    category: "relationships",
    keywords: ["trauma bond", "relationship", "push pull", "loyalty", "leaving", "cycle"],
  },
  relationships: {
    category: "relationships",
    keywords: ["relationship", "partner", "conflict", "communication", "closeness"],
  },
  "people-pleasing": {
    category: "relationships",
    keywords: ["fawn", "pleasing", "approval", "saying no", "self-abandonment"],
  },
  boundaries: {
    category: "relationships",
    keywords: ["boundaries", "saying no", "limits", "guilt", "over-giving"],
  },
  "self-worth": {
    category: "self-identity",
    keywords: ["shame", "self-worth", "not good enough", "self-esteem", "self-blame"],
  },
  dissociation: {
    category: "daily-life",
    keywords: ["spacing out", "unreal", "detached", "foggy", "time loss", "autopilot"],
  },
};
